
import { useShallow } from 'zustand/react/shallow'
import useAuthoringTranslations from '../../../../hooks/stores/useAuthoringTranslations';

const ObjectFieldTemplate = (props) => {
  const { properties, uiSchema, idSchema } = props;

  const {
    isTranslationActive,
    selectedLanguage,
  } = useAuthoringTranslations(
    useShallow((state) => ({
      isTranslationActive: state.isTranslationActive,
      selectedLanguage: state.selectedLanguage,
    }))
  )


  const options = uiSchema["ui:options"];
  let title = ""
  let schemaClassNames = {}
  const jpath = idSchema.$id.split(".").join("_")

  if (options) {
    schemaClassNames = options?.classNames
    title = options.title
    if (isTranslationActive && selectedLanguage && options?.translations?.[selectedLanguage]?.title) {
      title += ` (${options.translations[selectedLanguage].title})`
    }
  }

  let objectContainerClassNames = [`rjs-object-container${options?.hide ? ' hidden' : ''}`]
  if (schemaClassNames?.objectContainer) objectContainerClassNames.push(schemaClassNames.objectContainer)

  return (
    <div
      id={jpath + "-container"}
      className="rjs-object-container">
      {title && <div
        className="rjs-object-title-wrapper">
        <div
          className={`rjs-object-title-container ${schemaClassNames?.objectTitleContainer ? schemaClassNames.objectTitleContainer : ""}`}>
          <div className={`rjs-object-title ${schemaClassNames?.objectTitle ? schemaClassNames.objectTitle : ""}`}>
            {title}
          </div>
        </div>
      </div>}
      <div className={`rjs-object-inner-container ${schemaClassNames?.objectInnerContainer ? schemaClassNames.objectInnerContainer : ""}`}>
        {properties.map((prop, i) => {
          const { uiSchema } = prop.content.props;
          const options = uiSchema["ui:options"];
          const jpath = prop.content.props.idSchema["$id"].split(".").join("_")

          let fieldClassNames = ["rjs-field-container"];

          if (isTranslationActive) {
            fieldClassNames.push("rjs-full")

            if (jpath === "root_protocol_type_of_research") {
              let el = fieldClassNames[1].replace("pr-8", "pr-24")
              fieldClassNames[1] = el
            } else if (jpath === "root_protocol_study_type") {
              let el = fieldClassNames[1].replace("pl-8", "pl-24")
              fieldClassNames[1] = el
            }
          } else if (options?.classNames?.fieldContainer) {
            fieldClassNames.push(options.classNames.fieldContainer)
          }

          if (options?.hide) return null;

          return (
            <div
              className={fieldClassNames.join(" ")}
              key={prop.name + "-" + "i"}
              id={jpath + "-field-container"}>
              {prop.content}
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default ObjectFieldTemplate;